import { Snippet } from './snippet.model';

export class RagResultMeta {
  count!: number;
  mostFrequentAnswer: string | null = null;
  parametersEcho: Record<string, unknown> = {};

  constructor(data: any = {}) {
    this.count = data.count;
    this.mostFrequentAnswer = data.most_frequent_answer ?? null;
    this.parametersEcho = data.parameters_echo ?? {};
  }
}

export class RagResult {
  question!: string;
  snippets: Snippet[] = [];
  meta!: RagResultMeta;

  constructor(data: any = {}) {
    this.question = data.question;
    this.snippets = (data.snippets ?? []).map((s: object) => new Snippet(s));
    this.meta = new RagResultMeta(data.meta);
  }
}
